"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "falconara-marittima": {
    "ac666596": [{
      "hkey": "4383269f",
      "slug": "falconara-alta-mezzacosta",
      "name": "Falconara Alta-Mezzacosta",
      "primary": true,
      "skipSearch": false
    }],
    "falconara-alta": [{
      "hkey": "4383269f",
      "slug": "falconara-alta-mezzacosta",
      "name": "Falconara Alta-Mezzacosta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2be982fb": [{
      "hkey": "5603b66e",
      "slug": "castelferretti",
      "name": "Castelferretti",
      "primary": true,
      "skipSearch": false
    }],
    "falconara-nord": [{
      "hkey": "5603b66e",
      "slug": "castelferretti",
      "name": "Castelferretti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "falconara-marittima"
    }],
    "1988825a": [{
      "hkey": "4383269f",
      "slug": "falconara-alta-mezzacosta",
      "name": "Falconara Alta-Mezzacosta",
      "primary": true,
      "skipSearch": false
    }],
    "mezzacosta": [{
      "hkey": "4383269f",
      "slug": "falconara-alta-mezzacosta",
      "name": "Falconara Alta-Mezzacosta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "falconara-marittima"
    }],
    "bb29cfb3": [{
      "hkey": "4d1f69cf",
      "slug": "falconara-marittima",
      "name": "Falconara Marittima",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "4d1f69cf",
      "slug": "falconara-marittima",
      "name": "Falconara Marittima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "557c3c3c": [{
      "hkey": "6ba8adfa",
      "slug": "fiumesino-villanova",
      "name": "Fiumesino-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "zona-industriale": [{
      "hkey": "6ba8adfa",
      "slug": "fiumesino-villanova",
      "name": "Fiumesino-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;